// src/js/helpers/localStorage.js
function getLocalStorage(key) {
  let stringVal = localStorage.getItem(key);
  if (stringVal === null) {
    return null;
  }
  let parsedVal;
  try {
    parsedVal = JSON.parse(stringVal);
  } catch (e) {
    return stringVal;
  }
  return parsedVal;
}
function setLocalStorage(key, val) {
  var stringVal = JSON.stringify(val);
  localStorage.setItem(key, stringVal);
  return val;
}

// src/js/cart/constants.js
var LOCAL_STORAGE_KEY_CART_DATA = "muradCartData";
var LOCAL_STORAGE_KEY_CART_DEBUG = "muradCartDebug";
var LOCAL_STORAGE_KEY_GWP_USER_INPUT_CODES = "muradCartGwpUserInputCodes";
var LOCAL_STORAGE_KEY_GWP_THEME_DATA = "muradCartGwpThemeData";
var LOCAL_STORAGE_KEY_GWP_COLLECTION_DATA = "muradCartGwpCollectionData";
var LOCAL_STORAGE_KEY_GWP_CURRENCY_SYMBOL = "muradCartGwpCurrencySymbol";
var GWP_WITHOUT_CODE_DUMMY_HASH = "GWP_WITHOUT_CODE";
var DOM_EVENT_NAME_CART_ADD = "muradCartAdd";
var DOM_EVENT_NAME_CART_ADD_ONE = "muradCartAddOne";
var DOM_EVENT_NAME_CART_REFRESH = "muradCartRefresh";
var CART_LINE_ITEM_QUANTITY_MAX_DEFAULT = 6;
var DEBUG_OUTLINE_DURATION_MS = 2e3;
var CART_DATA_STALE_AFTER_MS = 1e3 * 60;
var ON_CHANGE_DEBOUNCE_TIMER = 300;
var PUB_SUB_EVENTS = {
  cartAddRequest: "CART_ADD_REQUEST",
  cartChangeRequest: "CART_CHANGE_REQUEST",
  cartUpdateRequest: "CART_UPDATE_REQUEST",
  cartClearRequest: "CART_CLEAR_REQUEST",
  cartMutationComplete: "CART_MUTATION_COMPLETE",
  cartInFlight: "CART_IN_FLIGHT"
  // cartError: 'cart-error',
};
var PUB_SUB_PAYLOADS = {
  CART_ADD_REQUEST: ({ variantArray }) => ({
    // variantArray = [{ id: 0, quantity: 0, selling_plan: 0, properties: {} }],
    variantArray
  }),
  CART_CHANGE_REQUEST: ({ id, line, quantity, sellingPlanId, variantId }) => ({
    id,
    line,
    quantity,
    sellingPlanId,
    variantId
  }),
  CART_UPDATE_REQUEST: ({ variantQuantityMap }) => ({
    variantQuantityMap
  }),
  CART_CLEAR_REQUEST: () => null,
  CART_MUTATION_COMPLETE: ({ cartData }) => ({
    // cartData is shaped by shapeCartData()
    // consider value in adding a "source" prop to payload, e.g. if want to ensure a component doesn't react to an update it published;
    cartData
  }),
  CART_IN_FLIGHT: ({ isInFlight, id, line }) => ({
    isInFlight,
    id,
    line
  })
};

// src/js/cart/cartDebug.js
function getCartDebugLocalStorage() {
  return getLocalStorage(LOCAL_STORAGE_KEY_CART_DEBUG);
}
function getCartDebugState() {
  const cartDebugLocalStorage = getCartDebugLocalStorage();
  return parseInt(cartDebugLocalStorage) === 1;
}
function cartDebug(...params) {
  if (getCartDebugState() !== true) {
    return;
  }
  const LOG_STYLES_STRING = "color: #fff; font-size: 1.0rem; background-color: blue; padding: 4px";
  const LOG_STYLES_OBJECT = "color: #fff; font-size: 1.0rem; background-color: green; padding: 4px";
  if (typeof params[0] === "function") {
    console.log("%cfunction" + params[0], LOG_STYLES_STRING);
    this.testPerformance(...params);
  } else if (typeof params[0] === "string") {
    console.log("%c" + params[0], LOG_STYLES_STRING, ...params.slice(1));
  } else if (params.length === 1 && typeof params[0] === "object") {
    Object.keys(params[0]).forEach((key) => {
      console.log("%c" + key, LOG_STYLES_OBJECT, params[0][key]);
    });
  } else {
    for (let param of params) {
      if (typeof param === "string") {
        console.log("%c" + param, LOG_STYLES_STRING);
      } else {
        console.log("%c" + typeof param, LOG_STYLES_OBJECT, param);
      }
    }
  }
}
function debugOutlineElements(els = [], color = "blue", offset = -3) {
  els.forEach((el) => {
    if (el) {
      el.style.outline = `3px solid ${color}`;
      el.style.outlineOffset = `${offset}px`;
      setTimeout(() => {
        el.style.outline = "none";
        el.style.outlineOffset = "unset";
      }, DEBUG_OUTLINE_DURATION_MS);
    }
  });
}
function setCartDebugLocalStorageDefault() {
  setLocalStorage(LOCAL_STORAGE_KEY_CART_DEBUG, 0);
}
function init() {
  if (getCartDebugLocalStorage() === null) {
    setCartDebugLocalStorageDefault();
  }
}
init();

// src/js/cart/debounceThrottle.js
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// src/js/cart/pubsub.js
var cartEventSubscriptions = {};
var cartEventSubLog = [];
var cartEventPubLog = [];
window.cartEventData = {
  subscriptions: cartEventSubscriptions,
  subLog: cartEventSubLog,
  pubLog: cartEventPubLog
};
var logPubSub = debounce(() => cartDebug(window.cartEventData), 1e3);
function subscribe(eventName, callback, subscriberId = "") {
  cartEventSubLog.push({ type: "sub", eventName, subscriberId });
  if (cartEventSubscriptions[eventName] === void 0) {
    cartEventSubscriptions[eventName] = [];
  }
  cartEventSubscriptions[eventName] = [
    ...cartEventSubscriptions[eventName],
    { subscriberId, callback }
  ];
  logPubSub();
  return function unsubscribe() {
    cartEventSubLog.push({ type: "unsub", eventName, subscriberId });
    cartEventSubscriptions[eventName] = cartEventSubscriptions[eventName].filter((subs) => {
      return subs.callback !== callback;
    });
  };
}
function publish(eventName, data) {
  cartDebug({ eventName, data });
  cartEventPubLog.push({
    eventName,
    data,
    subCount: cartEventSubscriptions[eventName]?.length ?? 0
  });
  if (cartEventSubscriptions[eventName]) {
    cartEventSubscriptions[eventName].forEach((subs) => {
      subs.callback(data);
    });
  }
  logPubSub();
}

export {
  getLocalStorage,
  setLocalStorage,
  LOCAL_STORAGE_KEY_CART_DATA,
  LOCAL_STORAGE_KEY_GWP_USER_INPUT_CODES,
  LOCAL_STORAGE_KEY_GWP_THEME_DATA,
  LOCAL_STORAGE_KEY_GWP_COLLECTION_DATA,
  LOCAL_STORAGE_KEY_GWP_CURRENCY_SYMBOL,
  GWP_WITHOUT_CODE_DUMMY_HASH,
  DOM_EVENT_NAME_CART_ADD,
  DOM_EVENT_NAME_CART_ADD_ONE,
  DOM_EVENT_NAME_CART_REFRESH,
  CART_LINE_ITEM_QUANTITY_MAX_DEFAULT,
  CART_DATA_STALE_AFTER_MS,
  ON_CHANGE_DEBOUNCE_TIMER,
  PUB_SUB_EVENTS,
  PUB_SUB_PAYLOADS,
  getCartDebugState,
  cartDebug,
  debugOutlineElements,
  debounce,
  subscribe,
  publish
};
